import { LoadingLoop, Modal, Select, TextInput } from '@medeloop/medeloop-components-library';
import { useNavigate, useParams } from 'react-router-dom';
import { useOrganizationDetailsContext } from './organization-details';
import { useState } from 'react';
import { OrganizationResearcherRole } from 'src/types/organizations';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@tanstack/react-query';
import { inviteResearcherToOrganization } from 'src/api/organizations';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthToken } from 'src/store/selectors';
import { showToast } from 'src/store/toast';

export const InviteResearcherPage = () => {
  const token = useSelector(selectAuthToken);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { container } = useOrganizationDetailsContext();

  const { t } = useTranslation();

  const { organizationId } = useParams();

  if (!organizationId) {
    navigate(-1);
    return;
  }

  const [email, setEmail] = useState('');
  const [role, setRole] = useState<OrganizationResearcherRole>(
    OrganizationResearcherRole.RESEARCHER,
  );

  const inviteResearcherMutation = useMutation({
    mutationFn: () => {
      return inviteResearcherToOrganization({
        token,
        organizationId,
        email,
        role,
      });
    },
    onSuccess: () => {
      dispatch(
        showToast({
          message: t('researcher_invited_successfully'),
          type: 'success',
        }),
      );
      navigate(-1);
    },
  });

  const handleInvite = () => {
    inviteResearcherMutation.mutate();
  };

  return (
    <Modal
      isOpen
      title={t('invite_researcher')}
      disabled={!email || !role}
      container={container}
      actionType="primary"
      actionText={t('invite')}
      actionFunction={handleInvite}
      onCancel={() => navigate(-1)}
    >
      {inviteResearcherMutation.isPending ? (
        <div className="flex items-center justify-center">
          <LoadingLoop className="w-16" />
        </div>
      ) : (
        <>
          <TextInput
            label={t('email_header')}
            placeholder={'email@example.com'}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <Select
            label={t('role_header').slice(0, -1)} // remove last character (s)
            value={role}
            onValueChange={(value: OrganizationResearcherRole) => setRole(value)}
            options={[
              { label: t('researcher'), value: OrganizationResearcherRole.RESEARCHER },
              { label: t('admin'), value: OrganizationResearcherRole.ADMIN },
            ]}
          />
        </>
      )}
    </Modal>
  );
};
